module.exports = __webpack_public_path__ + "static/media/circle icon-2.ccb6ac9d.png";